import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class DedupeSlashInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const cleanedUrl = this.normalizeUrl(req.url);
    const cloned = cleanedUrl !== req.url ? req.clone({ url: cleanedUrl }) : req;
    return next.handle(cloned);
  }

  private normalizeUrl(url: string): string {
    const protocolMatch = url.match(/^([a-zA-Z][a-zA-Z\d+.-]*:\/\/)(.*)$/);
    if (protocolMatch) {
      const protocol = protocolMatch[1];
      const rest = protocolMatch[2].replace(/\/{2,}/g, '/');
      return protocol + rest;
    }
    return url.replace(/\/{2,}/g, '/');
  }
}